window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['x-apikey'] = '123456';



let langPrefix = $('html').attr('lang') === 'ru' ? '/ru' : '';
let token = $('meta[name="csrf-token"]').attr('content');
import Parallax from 'parallax-js'
require('jquery-validation');

import language from "./modules/lang";
let Swal = require('sweetalert2');


let isMobile;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) || $(window).width() <= 991) {
    isMobile = true;
} else isMobile = false;



$(function () {

    if (isMobile) {
        $('.animate').removeClass('animate').css('visibility', 'visible')
    }


    (function ($) {
        var methods;
        methods = {
            init: function (elements, options) {
                $(window).scroll(function () {
                    methods.animate(elements, options);
                });
                $(window).trigger('scroll');
            },
            animate: function (elements, options) {
                var viewBottom, viewHeight, viewTop;
                viewHeight = $(window).height();
                viewTop = $(window).scrollTop();
                viewBottom = viewTop + viewHeight;
                $.each(elements, function () {
                    var elementAnimated, elementAnimation, elementBottom, elementDelay, elementDuration, elementHeight, elementIteration, elementOffset, elementTop;
                    elementAnimated = 'animated';
                    elementAnimation = $(this).data('animate');
                    elementOffset = $(this).data('offset');
                    elementDuration = $(this).data('duration');
                    elementDelay = $(this).data('delay');
                    elementIteration = $(this).data('iteration');
                    elementHeight = $(this).outerHeight();
                    elementTop = $(this).offset().top;
                    elementBottom = elementTop + elementHeight;
                    if (elementOffset) {
                        elementTop = elementTop + elementOffset;
                        elementBottom = elementBottom - elementOffset;
                    }
                    if (options.animateCssVersion === 4) {
                        elementAnimated = 'animate__animated';
                        elementAnimation = 'animate__' + elementAnimation;
                    }
                    $(this).css({
                        '-webkit-animation-duration': elementDuration,
                        'animation-duration': elementDuration
                    });
                    $(this).css({
                        '-webkit-animation-delay': elementDelay,
                        'animation-delay': elementDelay
                    });
                    $(this).css({
                        '-webkit-animation-iteration-count': elementIteration,
                        'animation-iteration-count': elementIteration
                    });
                    if (elementBottom >= viewTop && elementTop <= viewBottom) {
                        $(this).css('visibility', 'visible');
                        $(this).addClass(elementAnimation);
                        $(this).addClass(elementAnimated);
                    } else {
                        if (options.once === false) {
                            $(this).css('visibility', 'hidden');
                            $(this).removeClass(elementAnimation);
                            $(this).removeClass(elementAnimated);
                        }
                    }
                });
            }
        };
        jQuery.fn.scrolla = function (options) {
            options = $.extend({
                mobile: false,
                once: false,
                animateCssVersion: 4
            }, options);
            if (options.mobile === false) {
                if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return false;
                }
            }
            methods.init(this, options);
        };
    })(jQuery);




    // function AnimateOnScroll(targetClass, animationClass, resetOnScrollUp) {
    //     targetClass = "." + targetClass;
    //     let animationShow = false;
    //     jQuery(function ($) {
    //         $(window).scroll(function () {


    //             var windowBottom = $(this).scrollTop() + $(this).innerHeight();
    //             $(targetClass).each(function () {
    //                 var objectBottom = $(this).offset().top;
    //                 if (objectBottom < windowBottom) {
    //                     $(this).addClass('animate__' + animationClass + ' animate__animated');
    //                 } else if (resetOnScrollUp) {
    //                     $(this).removeClass('animate__' + animationClass + ' animate__animated');
    //                 }
    //             });
    //         }).scroll();
    //     });
    // };

    // AnimateOnScroll("box", "bounce", true)

    $('.animate').scrolla({
        once: true,
        mobile: false,
    });

    function toggleHeader(visibility) {
        if (visibility) {
            $('header').css('top', 0)
        } else {
            $('header').css('top', -80 + 'px')
        }
    }

    $('.burger-wrapper').on('click', function () {
        $(this).toggleClass('show')
    })


    $(window).scroll(function () {

        if ($(this).scrollTop() > ($('.about-us').offset().top - 150)) {
            if (!isMobile) toggleHeader(true)
        } else {
            if (!isMobile) toggleHeader(false)
        }
    })

    var scene = document.getElementById('scene');
    var scene2 = document.getElementById('scene2');
    var parallaxInstance = new Parallax(scene);
    var parallaxInstance2 = new Parallax(scene2);

    $('#feedbackForm').on('submit', function (e) {
        e.preventDefault();
    })

    function getFormData($form) {
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    function formValidator(formName, info, callback) {
        let messageList = {
            email: {
                required: language('home.feedback.email.required'),
                email: language('home.feedback.email.email')
            },
            name: {
                required: language('home.feedback.name.required')
            },
            phone: {
                required: language('home.feedback.phone.required')
            }
        };
        let rulesList = {
            email: {
                required: true,
                email: true
            },
            name: {
                required: true
            },
            phone: {
                required: true
            }
        };

        let csrf = $('[name="csrf-token"]').attr('content');


        $(formName).validate({
            rules: rulesList,
            messages: messageList,
            submitHandler: function submitHandler(form) {
                $.ajax({
                    url: '/feedback/',
                    type: "POST",
                    data: getFormData($('#feedbackForm')),
                    headers: {
                        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                        "X-CSRF-TOKEN": csrf
                    },
                    success: function (data) {
                        if(data.success){
                            $(formName).find('input[type="text"]').val('');
                            Swal.fire({
                                title: 'Спасибо!',
                                text: 'Наш менеджер свяжется с Вами в ближайшее время',
                                icon: 'success',
                                confirmButtonText: 'Продолжить',
                                showDenyButton: true,
                                timer: 5000,
                                timerProgressBar: true,
                                customClass: {
                                    confirmButton: 'customBtn'
                                }
                            })
                        }
                    },
                    error: function (msg) {
                        Swal.fire({
                            title: 'Ошибка!',
                            text: 'Что-то пошло не так, попробуйте заполнить форму немного позже!',
                            icon: 'error',
                            confirmButtonText: 'Продолжить',
                            showDenyButton: true,
                            customClass: {
                                confirmButton: 'customBtn'
                            }
                        })
                    }
                });
            },
            errorElement: 'span'
        });
    }

    formValidator('#feedbackForm')

    $('.topBtn').on('click', function () {
        window.scrollTo({ top: 0 });
    })

    
})